import { useEffect, useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import Input from "../reusable_components/Input";
import postData from "../custom_functions/postData";
import Select from "../reusable_components/Select";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer } from "../utils/style";


function AddLocation(props) {
    const [formType, setFormType] = useState('HUB');
    const [formData, setFormData] = useState({});
    const [hubs, setHubs] = useState([]);
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);

    const requiredFields = ['name', 'address', 'contactPerson', 'inventoryCapacity', 'lat', 'lng'];

    useEffect(() => { fetchHubs() }, [])
    console.log(window.location.search)

    function updateFormData(e) {
        const { name, value } = e.target;
        var data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    function updateCoordinates() {
        navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            let data = { ...formData };
            data.lat = latitude;
            data.lng = longitude;
            setFormData(data);
        })
    }

    async function addLocation() {
        if (
            formData.name && formData.name.length > 0 &&
            formData.address && formData.address.length > 0 &&
            formData.contactPerson && formData.contactPerson.length > 0 &&
            formData.inventoryCapacity && formData.inventoryCapacity > 0 &&
            formData.lat &&
            formData.lng &&
            !inputErrors.includes('error') &&
            (formType === 'SPOKE' ? formData.hub_id : true)
        ) {
            console.log('Validated!')
            console.log(formData)
            const query = window.location.search;
            var code;
            var state;
            var realmId;
            var quickBookUrl = `${window.location.origin}/inventory/locations`
            if (query && query.length > 0) {
                const splitedList = query.split('?')[1]
                const splitedList1 = splitedList.split('&')
                code = splitedList1[0].split("=")[1];
                state = splitedList1[1].split("=")[1];
                realmId = splitedList1[2].split("=")[1];
            }
            postData(`${url}/location`, { ...formData, type: formType, code, state, realmId, quickBookUrl }, (error) => {
                toast.error(error.response.data.message, { autoClose: 3000 })
                props.setShowModal(false);
            }, (data) => {
                toast.success(data.message, { autoClose: 3000 })
                props.setShowModal(false);
                props.reload(1 + Math.random())
            }
            )
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    async function fetchHubs() {
        try {
            const reqUrl = url + '/hubs';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            setHubs(data.data);
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className={modalContainer}>
            <div className="px-4 flex justify-center flex-col w-2/3">
                <div className="">
                    <div className="flex">
                        <button onClick={() => setFormType('HUB')} className={`${formType === 'HUB' ? 'text-white bg-gray-500' : 'bg-white'} font-semibold border border-black flex justify-center items-center py-2 px-10 rounded-md cursor-pointer font-family-audiowide mr-4`}>HUB</button>
                        <button onClick={() => setFormType('SPOKE')} className={`${formType === 'SPOKE' ? 'text-white bg-gray-500' : 'bg-white'} font-semibold border border-black flex justify-center items-center py-2 px-10 rounded-md cursor-pointer font-family-audiowide`}>SPOKE</button>
                    </div>
                </div>
                <div className="rounded-lg bg-white w-full p-8">
                    {
                        formType === 'SPOKE' &&
                        <div className="grid grid-cols-4 py-2 px-2">
                            <label className={label}>Select Parent Hub</label>
                            <div className="col-span-2">
                                <Select
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    required={true}
                                    valueKey={'id'}
                                    nameKey={'name'}
                                    name="hub_id"
                                    options={hubs}
                                    className={inputStyle}
                                    placeHolder="PARENT HUB"
                                    onChange={e => updateFormData(e)}
                                />
                            </div>
                        </div>
                    }
                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Name</label>
                        <div className="col-span-2">
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="name"
                                type='text'
                                className={inputStyle}
                                placeHolder="Enter Name"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Address</label>
                        <div className="col-span-2">
                            <Input
                                index={2}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="address"
                                type='text'
                                className={inputStyle}
                                placeHolder="Enter Address"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Contact Person</label>
                        <div className="col-span-2">
                            <Input
                                index={3}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="contactPerson"
                                type='text'
                                className={inputStyle}
                                placeHolder="Enter Contact Person"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <label className={label}>Inventory Capacity</label>
                        <div className="col-span-2">
                            <Input
                                index={4}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="inventoryCapacity"
                                type='number'
                                className={inputStyle}
                                placeHolder="Enter Inventory Capacity"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-6 gap-4 py-1 px-2">
                        <label className={label}>Coordinates</label>
                        <div className="col-span-2">
                            <Input
                                index={5}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                name="lat"
                                disabled={true}
                                value={`${formData.lat}/${formData.lng}`}
                                className={inputStyle}
                                placeHolder="Enter Coordinates"
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <button className={"text-xs border border-customOne rounded-lg text-center text-customOne font-semibold cursor-pointer h-8 mt-2"} onClick={() => updateCoordinates()}>Get Location</button>
                    </div>
                    <div className="flex justify-between py-3 px-32 gap-8">
                        <button onClick={() => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                        <Button clickHandler={() => addLocation()} className={btnOne} name={'Submit'} />
                    </div>
                    <div className="text-red-500 font-semibold text-center">
                        {
                            showInputError && 'Please fill all the fields as directed!'
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddLocation;